<div class="book-event-slot-subheader">
  {{ "APP.BOOKING_SLOTS.PARTICIPANTS.CHOOSE_PAYMENT" | translate }}
</div>
<div class="book-event-slot-cards">
  <div
    class="book-event-slot-card"
    [class.selected]="chosenPayment && chosenPayment === AddParticipantPaymentType.PAID_IN_CASH"
    (click)="choosePayment(AddParticipantPaymentType.PAID_IN_CASH)"
  >
    <div class="card-content">
      <div class="card-title">
        {{ getPaymentTitle(AddParticipantPaymentType.PAID_IN_CASH) }}
      </div>
      <div class="card-desc">
        <div class="price-wrapper">
          <div class="ticket-sales-info">
            <div class="sale-info">
              <div class="normal">
                {{ getPaymentDescription(AddParticipantPaymentType.PAID_IN_CASH) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="book-event-slot-card disabled-card"
    [class.selected]="chosenPayment && chosenPayment === AddParticipantPaymentType.PAYMENT_LINK"
    (click)="choosePayment(AddParticipantPaymentType.PAYMENT_LINK)"
  >
    <div class="card-content">
      <div class="card-title">
        {{ getPaymentTitle(AddParticipantPaymentType.PAYMENT_LINK) }}
      </div>
      <div class="card-desc">
        <div class="price-wrapper">
          <div class="ticket-sales-info">
            <div class="sale-info">
              <div class="normal">
                {{ getPaymentDescription(AddParticipantPaymentType.PAYMENT_LINK) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="book-event-slot-card disabled-card"
    [class.selected]="chosenPayment && chosenPayment === AddParticipantPaymentType.PREPAID_CODE"
    (click)="choosePayment(AddParticipantPaymentType.PREPAID_CODE)"
  >
    <div class="card-content">
      <div class="card-title">
        {{ getPaymentTitle(AddParticipantPaymentType.PREPAID_CODE) }}
      </div>
      <div class="card-desc">
        <div class="price-wrapper">
          <div class="ticket-sales-info">
            <div class="sale-info">
              <div class="normal">
                {{ getPaymentDescription(AddParticipantPaymentType.PREPAID_CODE) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="book-event-slot-card"
    [class.selected]="chosenPayment && chosenPayment === AddParticipantPaymentType.FREE_ENTRY"
    (click)="choosePayment(AddParticipantPaymentType.FREE_ENTRY)"
  >
    <div class="card-content">
      <div class="card-title">
        {{ getPaymentTitle(AddParticipantPaymentType.FREE_ENTRY) }}
      </div>
      <div class="card-desc">
        <div class="price-wrapper">
          <div class="ticket-sales-info">
            <div class="sale-info">
              <div class="normal">
                {{ getPaymentDescription(AddParticipantPaymentType.FREE_ENTRY) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="book-event-slot-card disabled-card"
    [class.selected]="chosenPayment && chosenPayment === AddParticipantPaymentType.CUSTOM"
    (click)="choosePayment(AddParticipantPaymentType.CUSTOM)"
  >
    <div class="card-content">
      <div class="card-title">
        {{ getPaymentTitle(AddParticipantPaymentType.CUSTOM) }}
      </div>
      <div class="card-desc">
        <div class="price-wrapper">
          <div class="ticket-sales-info">
            <div class="sale-info">
              <div class="normal">
                {{ getPaymentDescription(AddParticipantPaymentType.CUSTOM) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
